module.exports = __webpack_public_path__ + "static/media/deliveryVan_red.caf047ac.svg";